import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export class Animation {
  constructor() {
    document.addEventListener("DOMContentLoaded", () => {
      this.parallax();
      this.gallery();
    });
  }

  parallax() {
    const images = document.querySelectorAll(".parallax");

    if (images) {
      images.forEach((p) => {
        const image = p.querySelector("img");

        gsap.set(image, {
          scale: 1.3,
        });

        let startPos = "top bottom";

        gsap.to(image, {
          yPercent: 10,
          scrollTrigger: {
            trigger: p,
            scrub: true,
            start: startPos,
            end: "bottom top",
          },
        });
      });
    }
  }

  gallery() {
    const gallery = document.querySelectorAll(
      ".gallery-wrapper .dekstop .group"
    );
    const galleryWrapper = document.querySelector(".gallery-wrapper");

    if (gallery && innerWidth > 800) {
      gallery.forEach((item, index) => {
        if (index !== 1) {
          gsap.to(item, {
            yPercent: -10,
            scrollTrigger: {
              trigger: galleryWrapper,
              start: "top top",
              end: "bottom bottom",
              scrub: true,
            },
          });
        }
      });
    }
  }
}

const aniamationTextJumbotron = () => {
  const lists = document.querySelectorAll(".jumbotron .list");

  const stagger = document.querySelectorAll(".jumbotron .stagger");

  const animateStart = () => {
    return {
      y: 0,
      duration: 1,
      opacity: 1,
      stagger: {
        each: 0.07,
        from: "end",
      },
      ease: "power3.inOut",
    };
  };

  const animateEnd = () => {
    return {
      y: -20,
      duration: 1,
      opacity: 0,
      stagger: {
        each: 0.07,
        from: "end",
      },
      ease: "power3.inOut",
    };
  };

  if (lists && lists.length > 0) {
    lists.forEach((item) => {
      const text = item.innerHTML;
      item.innerHTML = "";

      [...text].forEach((t) => {
        const newText = document.createElement("div");
        newText.innerHTML = t;
        item.appendChild(newText);
      });
    });
    const tl = gsap.timeline();

    const textA = lists[0].querySelectorAll("div");
    const textB = lists[1].querySelectorAll("div");
    const textC = lists[2].querySelectorAll("div");
    const textD = lists[3].querySelectorAll("div");

    tl.to([...textA], animateStart())
      .to([...textA], animateEnd())

      .to([...textB], animateStart(), "-=1")
      .to([...textB], animateEnd())

      .to([...textC], animateStart(), "-=1")
      .to([...textC], animateEnd())
      .to([...textD], animateStart(), "-=1");

    gsap.to(stagger, {
      opacity: 1,
      y: 0,
      duration: 2,
      ease: "power4.inOut",
      stagger: 0.1,
      onComplete: () => {
        tl.play();
      },
    });
  }
};

const stickyContentOverview = () => {
  const sticky = document.querySelector(".sticky-map .map");
  const trigger = document.querySelector(".listing-wrapper-front");

  ScrollTrigger.create({
    trigger: sticky,
    pin: sticky,
    start: "top top",
    endTrigger: trigger,
    end: "bottom bottom",
  });
};

document.addEventListener("DOMContentLoaded", () => {
  aniamationTextJumbotron();

  stickyContentOverview();
});
